import { render, staticRenderFns } from "./PresetDeliveryComponent.vue?vue&type=template&id=66e71941&scoped=true&"
import script from "./PresetDeliveryComponent.vue?vue&type=script&lang=js&"
export * from "./PresetDeliveryComponent.vue?vue&type=script&lang=js&"
import style0 from "./PresetDeliveryComponent.vue?vue&type=style&index=0&id=66e71941&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e71941",
  null
  
)

export default component.exports